// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.poa-data .details-value,\n.poa-data .details-value input,\n.poa-data .details-value textarea,\n.poa-data .details-value button {\n  text-transform: uppercase;\n}\n.invalid-value .details-label,\n.invalid-value .dropdown-readonly {\n  color: #f4516c;\n}\n.valid-value .details-label,\n.valid-value .dropdown-readonly {\n  color: #28a745;\n}\n", ""]);
// Exports
module.exports = exports;
